import { Box, Button } from "@mui/material";
import { handleSaveDataSubmit } from "./BaseBudgetSaveFunctions";

export const SaveDataButton = ({ gridRef, setSaveData, onSaveDataBefore = null }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 1000,
        display: "flex",
        justifyContent: "right",
      }}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={() => handleSaveDataSubmit(gridRef, setSaveData, onSaveDataBefore)}
        sx={{
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          "&:hover": {
            boxShadow: "0 6px 10px rgba(0,0,0,0.2)",
          },
        }}
      >
        Submission
      </Button>
    </Box>
  );
};
